<template>
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.769 23.237A9.796 9.796 0 0 1 6.67 20.97a9.663 9.663 0 0 1-1.928-3.14 9.44 9.44 0 0 1-.607-3.604 9.247 9.247 0 0 1 .869-3.664A9.248 9.248 0 0 1 7.252 7.54a9.44 9.44 0 0 1 3.151-1.852 9.663 9.663 0 0 1 3.645-.541 9.794 9.794 0 0 1 3.728.916 9.732 9.732 0 0 1 4.652 4.54.718.718 0 0 1-.34.974.755.755 0 0 1-.993-.352 8.24 8.24 0 0 0-3.935-3.84c-4.09-1.908-8.939-.2-10.807 3.805-1.868 4.005-.059 8.817 4.032 10.724 4.09 1.908 8.94.2 10.807-3.805.17-.364.61-.52.983-.346.372.174.536.61.366.976a9.247 9.247 0 0 1-2.248 3.02 9.44 9.44 0 0 1-3.151 1.852 9.663 9.663 0 0 1-3.645.541 9.785 9.785 0 0 1-3.728-.916Z"
      :fill="disabled ? disabledColor : color"
      :stroke="disabled ? disabledColor : color"
      stroke-width=".3"
    />
    <path
      d="M18.338 11.811a.717.717 0 0 1-.395-.797.725.725 0 0 1 .848-.57l2.822.564 1.01-2.983a.716.716 0 1 1 1.356.455l-1.216 3.588a.722.722 0 0 1-.824.48l-3.442-.687a.679.679 0 0 1-.159-.05Z"
      :fill="disabled ? disabledColor : color"
      :stroke="disabled ? disabledColor : color"
      stroke-width=".3"
    />
  </svg>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class EnterIcon extends Vue {
  @Prop() disabled: boolean;
  @Prop({ type: String, default: '#FFFFFF' }) color: boolean;
  @Prop({ type: String, default: '#9FAAD2' }) disabledColor: boolean;
}
</script>
